import { Component } from '@angular/core';

@Component({
  selector: 'app-blog-standard',
  templateUrl: './blog-standard.component.html',
  styleUrl: './blog-standard.component.css'
})
export class BlogStandardComponent {
  blog = {
  image: "assets/images/blog-1.jpg",
  title: "Top UI/UX Practices to Follow in 2025"
  };

  comments = [
  {
    img: "assets/images/avatar-1.jpg",
    name: "Nadia Farooq",
    date: "24 Jun 2025",
    text: "This article was very informative! I especially liked the part about personalized UI. Looking forward to implementing some of these tips."
  },
  {
    img: "assets/images/avatar-2.jpg",
    name: "Ali Haider",
    date: "22 Jun 2025",
    text: "Great insights! Minimal design with purpose is something every designer should focus on."
  },
  {
    img: "assets/images/avatar-3.jpg",
    name: "Natalie Doe",
    date: "20 Jun 2025",
    text: "I appreciate the emphasis on accessibility. It's so important and often overlooked."
  }
  ];

  categories = [
  "Web Design",
  "Web Development",
  "Keyword Research",
  "Email Marketing"
  ];

  recentPosts = [
  {
  img:"assets/images/post-1.jpg",
  title:"Top Tips for Clean Website Layouts"
  },
  {
  img:"assets/images/post-2.jpg",
  title:"Boost Engagement with Interactive Elements"
  },
  {
  img:"assets/images/post-3.jpg",
  title:"Choosing the Right Typography for Web"
  },
  {
  img:"assets/images/post-4.jpg",
  title:"Designing for Mobile What to Know"
  },
  {
  img:"assets/images/post-5.jpg",
  title:"SEO Basics Every Designer Should Know"
  },
  {
  img:"assets/images/post-6.jpg",
  title:"Color Theory for Effective Branding"
  }
  ];

  tags = [
  "Design","Development","Marketing","SEO","Writing","Consulting",
  "Design","Development","Marketing","SEO","Writing","Consulting"
  ];
}
